import Vue from "vue"

import store from "@/store/store";
import router from "@/router";
import { enumHttpStatusCode } from "@/enums/HttpStatusCode";


// Fait un appel à l'API et renvoie la réponse dans une Promise et affiche le loader durant la requête
// Actualise la page si erreur 401 (problème d'authentification, potentiellement token expiré)

let cacheResults = {};

function apiFetch(endpoint, cache = false, displayLoader = true) {

  // On affiche le loader si demandé
  if (displayLoader)
    store.commit("displayLoader", true);

  return new Promise((resolve, reject) => {
    if (cache && endpoint in cacheResults) {
      resolve(cacheResults[endpoint]);

      // On arrête le loader
      if (displayLoader)
        store.commit("displayLoader", false);

    } else {
      Vue.axios.get(store.state.rootApi + endpoint, {
        headers: {
          Authorization: "Bearer " + store.state.self.token
        }
      }).then((response => {
        if (cache) cacheResults[endpoint] = response.data;
        resolve(response.data);
      })).catch((e) => {
        if (e.response && e.response.status === enumHttpStatusCode.Unauthorized) { // non authentifié
          window.localStorage.removeItem("jwt");
          document.location.reload();
        } else if (e.response && e.response.status === enumHttpStatusCode.forbidden) { // non autorisé
          router.replace("/");
        }
        else
          reject(e);
      }).finally(() => {
        // On arrête le loader
        if (displayLoader)
          store.commit("displayLoader", false);
      })
    }
  })
}

function apiPost(endpoint, body) {
  store.commit("displayLoader", true);

  // On convertit l'objet "body" en FormData
  var fd = new FormData();
  if (body != undefined) {
    fd = objToFormdata(body);
  }

  return new Promise((resolve, reject) => {
    Vue.axios.post(store.state.rootApi + endpoint, fd, {
      headers: {
        Authorization: "Bearer " + store.state.self.token,
      }
    }).then((response => {
      resolve(response.data);
    })).catch((e) => {
      if (e.response && e.response.status === enumHttpStatusCode.Unauthorized) {
        window.localStorage.removeItem("jwt");
        document.location.reload();
      }
      else
        reject(e);
    }).finally(() => {
      store.commit("displayLoader", false);
    })
  })
}

function apiPostCustomBody(endpoint, body) {
  store.commit("displayLoader", true);

  return new Promise((resolve, reject) => {
    Vue.axios.post(store.state.rootApi + endpoint, body, {
      headers: {
        Authorization: "Bearer " + store.state.self.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response => {
      resolve(response.data);
    })).catch((e) => {
      if (e.response && e.response.status === enumHttpStatusCode.Unauthorized) {
        window.localStorage.removeItem("jwt");
        document.location.reload();
      }
      else
        reject(e);
    }).finally(() => {
      store.commit("displayLoader", false);
    })
  })
}

function apiPostMaps(endpoint, body) {
  store.commit("displayLoader", true);

  // On convertit l'objet "body" en FormData
  var fd = new FormData();
  if (body != undefined) {
    fd = objToFormdata(body);
  }

  return new Promise((resolve, reject) => {
    Vue.axios.post(store.state.rootApiMaps + endpoint, fd, {
      headers: {
        Authorization: "Bearer " + store.state.self.token,
      }
    }).then((response => {
      resolve(response.data);
    })).catch((e) => {
      if (e.response && e.response.status === enumHttpStatusCode.Unauthorized) {
        window.localStorage.removeItem("jwt");
        document.location.reload();
      }
      else
        reject(e);
    }).finally(() => {
      store.commit("displayLoader", false);
    })
  })
}


function apiFetchFile(endpoint) {
  store.commit("displayLoader", true);
  return new Promise((resolve, reject) => {
    Vue.axios.get(store.state.rootApi + endpoint, {
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + store.state.self.token,
      }
    }).then((response => {
      resolve(response.data);
    })).catch((e) => {
      if (e.response && e.response.status === enumHttpStatusCode.Unauthorized) { // non authentifié
        window.localStorage.removeItem("jwt");
        document.location.reload();
      } else if (e.response && e.response.status === enumHttpStatusCode.Forbidden) { // non autorisé
        router.replace("/");
      }
      else
        reject(e);
    }).finally(() => {
      store.commit("displayLoader", false);
    })
  })
}

function getCurrentModuleUrl() {
  let route = router.currentRoute.path
  route = route[0] == "/" ? route.slice(1) : route // On supprime le premier / s'il y a
  route = route[route.length - 1] == "/" ? route.slice(0, route.length - 1) : route; // On supprimer le dernier / s'il y a

  let moduleUrl = route;
  if (moduleUrl == "previsionnel-top-frs-supplier") moduleUrl = "previsionnel-top-frs";
  if (router.currentRoute.meta.baseUrl) { return router.currentRoute.meta.baseUrl; }

  return moduleUrl
}

function uniq(array, field="") {
  return array.filter((el, i) => {
    if (array.findIndex((_el) => (field ? _el[field] : _el) == (field ? el[field] : el)) == i)
      return true;
    return false;
  })
}

function calcPercent(number, total) {
  if (total == 0) return 0;
  const res = (number / total) * 100;
  return parseInt(res * 100) / 100 // Tricks pour arrondir au centième
}

function formatDate(date, display = false) {
  if (!date) return null;
  if (!display)
    return `${date.getFullYear()}-${(date.getMonth() + 1 < 10) ? "0" : ""}${date.getMonth() + 1}-${(date.getDate() < 10) ? "0" : ""}${date.getDate()}`
  else
    return `${(date.getDate() < 10) ? "0" : ""}${date.getDate()}/${(date.getMonth() + 1 < 10) ? "0" : ""}${date.getMonth() + 1}/${date.getFullYear()}`
}

function formatDateTime(date, display = false) {
  if (!date) return null;
  if (!display)
    return `${date.getFullYear()}-${(date.getMonth() + 1 < 10) ? "0" : ""}${date.getMonth() + 1}-${(date.getDate() < 10) ? "0" : ""}${date.getDate()}T${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}:${date.getSeconds() < 10 ? "0" : ""}${date.getSeconds()}`
  else
    return `${(date.getDate() < 10) ? "0" : ""}${date.getDate()}/${(date.getMonth() + 1 < 10) ? "0" : ""}${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}:${date.getSeconds() < 10 ? "0" : ""}${date.getSeconds()}`
}

export default { apiFetchFile, apiFetch, apiPost, apiPostCustomBody, apiPostMaps, getCurrentModuleUrl, uniq, calcPercent, formatDate, formatDateTime }
export { apiFetchFile, apiFetch, apiPost, apiPostCustomBody, apiPostMaps, getCurrentModuleUrl, uniq, calcPercent, formatDate, formatDateTime }



// Convertit un objet en FormData()
function objToFormdata(obj) {
  const formData = new FormData();
  Object.keys(obj).forEach(function (key) {
    formData.append(key, obj[key]);
  });
  return formData;
}



// WEBPACK FOOTER //
// ./src/utils/index.js